import { CommonModule } from '@angular/common';
import { Component, inject, Signal } from '@angular/core';
import { Subject } from 'rxjs';
import { SpinnerService } from '../../services/spinner.service';

@Component({
  selector: 'app-spinner',
  imports: [CommonModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss'
})
export class SpinnerComponent {
  private spinnerService = inject(SpinnerService);

	isLoading: Signal<boolean> = this.spinnerService.isLoading;
}
